import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <div className="about-content">
            <h1 className="page-title">회사소개</h1>
            <h2 className="main-quote">
              세금의 <span className="highlight">결</span>을 읽어, 오늘을 풀고 내일을 설계합니다
            </h2>
            <p className="description">
              세무회계 결은 깊이 있는 전문성과 섬세한 서비스로<br />
              고객의 성공적인 미래를 함께 만들어 가겠습니다.
            </p>
          </div>
        </div>
      </section>

      {/* Company Philosophy */}
      <section className="philosophy">
        <div className="container">
          <h2 className="section-title">세무회계 결</h2>
          <h3 className="philosophy-subtitle">"세무회계 결"은 다릅니다.</h3>
          
          <div className="philosophy-content">
            <div className="philosophy-text">
              <p className="philosophy-description">
                우리는 정형화된 세무 서비스 대신,<br />
                고객의 상황에 꼭 맞춘 해답을 제시합니다.
              </p>
              
              <p className="philosophy-description">
                다년간의 현장 경험과 최신 세법 지식을 갖춘 전문가들이<br />
                체계적 시스템과 이해하기 쉬운 소통으로<br />
                고객의 성장과 안정, 두 가지를 모두 책임집니다.
              </p>
              
              <p className="philosophy-description">
                세무회계 결은 세무 서비스의<br />
                새로운 기준을 제시합니다.
              </p>
              
              <p className="philosophy-highlight">
                고객의 성공과 절세가 곧 우리의 자산입니다.<br />
                언제나 고객의 입장에서 최선의 결과로 보여드리겠습니다.
              </p>
            </div>
            
            <div className="philosophy-feature">
              <div className="company-logo-card">
                <div className="logo-container">
                  <img 
                    src="/images/세무회계 결 ver 1.png" 
                    alt="세무회계 결 로고" 
                    className="company-logo"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Specialization */}
      <section className="specialization">
        <div className="container">
          <div className="specialization-content">
            <div className="specialization-text">
              <h2>병의원 세무 전문</h2>
              <p>
                세무회계 결은 일반적인 세무 업무는 물론, 병의원 세무에 특화된 전문 서비스를 제공합니다. 
                의료업계의 특수한 세무 환경과 규정을 깊이 이해하고 있어, 의료진들이 진료에만 집중할 수 
                있도록 세무 업무를 완벽하게 지원합니다.
              </p>
              <ul className="specialization-list">
                <li>의료업 특화 세무 컨설팅</li>
                <li>병의원 개업 및 폐업 세무</li>
                <li>의료기기 투자 세액공제</li>
                <li>의료진 소득세 최적화</li>
                <li>병의원 부가가치세 관리</li>
              </ul>
            </div>
            <div className="specialization-image">
              <div className="doctor-image-container">
                <img 
                  src="/images/doctor.png" 
                  alt="병의원 전문 세무 서비스" 
                  className="doctor-image"
                />
                <p>병의원 전문 세무 서비스</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Location */}
      <section className="location">
        <div className="container">
          <h2 className="section-title">오시는 길</h2>
          <p className="location-description">
            고객의 편의를 위해 서울본점과 울산지점을 운영하고 있습니다.
          </p>
          
          <div className="offices-grid">
            <div className="office-card main-office">
              <div className="office-header">
                <h3>서울본점</h3>
                <span className="office-badge">주사무실</span>
              </div>
              
              <div className="office-info">
                <div className="office-details">
                  <div className="info-row">
                    <strong>주소</strong>
                    <span>서울특별시 중랑구 망우로 177, 3층<br />(중화동, 삼성빌딩)</span>
                  </div>
                  
                  <div className="info-row">
                    <strong>전화번호</strong>
                    <span>02-6949-5003</span>
                  </div>
                  
                  <div className="info-row">
                    <strong>운영시간</strong>
                    <div className="hours-list">
                      <div>평일: 08:30 - 18:30</div>
                      <div>토요일: 11:00 - 16:00</div>
                      <div>일요일/공휴일: 휴무</div>
                    </div>
                  </div>
                </div>
                
                <div className="map-link">
                  <a 
                    href="https://maps.google.com?q=서울특별시+중랑구+망우로+177" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="map-btn"
                  >
                    지도로 보기
                  </a>
                </div>
              </div>
            </div>
            
            <div className="office-card branch-office">
              <div className="office-header">
                <h3>울산지점</h3>
                <span className="office-badge">지점사무실</span>
              </div>
              
              <div className="office-info">
                <div className="office-details">
                  <div className="info-row">
                    <strong>주소</strong>
                    <span>울산광역시 중구 종가6길 21, 혁신타워 9층<br />(우정동, 우정혁신타워)</span>
                  </div>
                  
                  <div className="info-row">
                    <strong>전화번호</strong>
                    <span>052-700-5003</span>
                  </div>
                  
                  <div className="info-row">
                    <strong>운영시간</strong>
                    <div className="hours-list">
                      <div>평일: 08:00 - 18:30</div>
                      <div>토요일/일요일/공휴일: 휴무</div>
                    </div>
                  </div>
                </div>
                
                <div className="map-link">
                  <a 
                    href="https://maps.google.com?q=울산광역시+중구+종가6길+21" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="map-btn"
                  >
                    지도로 보기
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="team">
        <div className="container">
          <h2 className="section-title">전문가 팀</h2>
          <p className="team-description">
            세무회계 결의 전문가들은 각자의 분야에서<br />
            풍부한 경험과 전문성을 갖추고 있으며, 고객의 성공을 위해 최선을 다하고 있습니다.
          </p>
          <div className="team-features">
            <div className="team-feature">
              <h3>세무사</h3>
              <p>국가공인 세무사 자격을 보유한 전문가들이 직접 상담하고 업무를 처리합니다</p>
            </div>
            <div className="team-feature">
              <h3>지속적 교육</h3>
              <p>끊임없이 변화하는 세법에 대응하기 위해<br />지속적인 연구를 통해 전문성을 유지합니다</p>
            </div>
            <div className="team-feature">
              <h3>고객 중심</h3>
              <p>고객의 입장에서 생각하고<br />고객의 성공이 우리의 성공입니다</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
